<div class="ibox detailed-view-ibox" *ngIf="dailyReportsService.showDetailedView && dailyReportsService.selectedItemData">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">{{dailyReportsService.selectedItemData.dailyReportNumber}}</div>
        <span class="close-detailed-view" (click)="closeDetailedView()">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form #form="ngForm" class="content" submittable autocomplete="off">
                <div class="row m-b-xs"
                     *ngIf="dailyReportsService.buildings.length > 1"
                     (dblclick)="setEditModeFor(dailyReportsService.selectedItemData, 'building', true, form)">
                    <div class="dv-label col-md-3">
                        <label>Building</label>
                    </div>
                    <div class="dv-value col-md-9" *ngIf="!dailyReportsService.selectedItemData.formFields.building.editMode">
                        <span>{{dailyReportsService.selectedItemData.buildingName || '-'}}</span>
                        <i *ngIf="dailyReportsService.selectedItemData.status === 'draft' && dailyReportsService.selectedItemData.isCanEdit"
                           class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(dailyReportsService.selectedItemData, 'building', true, form)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    </div>
                    <div class="dv-value-edit col-md-9" *ngIf="dailyReportsService.selectedItemData.formFields.building.editMode">
                        <select class="form-control"
                                name="building"
                                [ngModel]="dailyReportsService.selectedItemData.buildingId">
                            <option value=""></option>
                            <option *ngFor="let building of dailyReportsService.buildings" [value]="building.id">
                                {{building.name}}
                            </option>
                        </select>
                        <button type="button"(click)="applyChanges(dailyReportsService.selectedItemData, form, {building: form.value.building}, 'building')">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="setEditModeFor(dailyReportsService.selectedItemData, 'building', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <div class="row m-b-xs">
                    <div class="dv-label col-md-3">
                        <label>Status</label>
                    </div>
                    <div class="col-md-9">
                        <span class="label label-closed"
                              *ngIf="dailyReportsService.selectedItemData.status === 'closed'">
                            Closed
                        </span>
                        <span class="label label-draft"
                              *ngIf="dailyReportsService.selectedItemData.status === 'draft'">
                            Draft
                        </span>
                    </div>
                </div>

                <div class="row m-b-xs datepicker-wrapper"
                     (dblclick)="setEditModeFor(dailyReportsService.selectedItemData, 'startDate', true)">
                    <div class="dv-label col-md-3">
                        <label>Start Date</label>
                    </div>
                    <div class="dv-value col-md-9" *ngIf="!dailyReportsService.selectedItemData.formFields.startDate.editMode">
                        <span>{{dailyReportsService.selectedItemData.startDate ? (dailyReportsService.selectedItemData.startDate | date:'yyyy-MM-dd h:mma') : '-'}}</span>
                        <i *ngIf="dailyReportsService.selectedItemData.status === 'draft' && dailyReportsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(dailyReportsService.selectedItemData, 'startDate', true)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    </div>
                    <div class="dv-value-edit col-md-9 inlineDateAndTime directory-add-modal-date-field"
                         *ngIf="dailyReportsService.selectedItemData.formFields.startDate.editMode">
                        <mat-form-field>
                            <input matInput [(ngModel)]="dailyReportsService.selectedItemData.startDate"
                                   (focus)="dateFromPicker.open()" (click)="dateFromPicker.open()"
                                   name="startDate" [matDatepicker]="dateFromPicker" placeholder="Choose a date" required>
                            <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
                            <mat-datepicker #dateFromPicker></mat-datepicker>
                        </mat-form-field>
                        <div class="input-group bootstrap-timepicker timepicker" (click)="openTimepicker('#timepicker')">
                            <input id="timepicker" class="form-control input-small" name="startTime"
                                   [ngModel]="getTime(dailyReportsService.selectedItemData.startDate)" required>
                            <span class="input-group-addon"><i class="glyphicon glyphicon-time"></i></span>
                        </div>
                    </div>
                    <div class="dv-value-edit m-t-xs pull-right"
                         style="padding: 0 15px;"
                         *ngIf="dailyReportsService.selectedItemData.formFields.startDate.editMode">
                        <button type="button"
                                style="border-left: 1px solid #dedfe0;"
                                (click)="applyChanges(dailyReportsService.selectedItemData, form, {startDate: form.value.startDate}, 'startDate')">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button"
                                (click)="setEditModeFor(dailyReportsService.selectedItemData, 'startDate', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <div class="row m-b-xs datepicker-wrapper"
                     (dblclick)="setEditModeFor(dailyReportsService.selectedItemData, 'endDate', true)">
                    <div class="dv-label col-md-3">
                        <label>End Date</label>
                    </div>
                    <div class="dv-value col-md-9" *ngIf="!dailyReportsService.selectedItemData.formFields.endDate.editMode">
                        <span>{{dailyReportsService.selectedItemData.endDate ? (dailyReportsService.selectedItemData.endDate | date:'yyyy-MM-dd h:mma') : '-'}}</span>
                        <i *ngIf="dailyReportsService.selectedItemData.status === 'draft' && dailyReportsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(dailyReportsService.selectedItemData, 'endDate', true)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    </div>
                    <div class="dv-value-edit col-md-9 inlineDateAndTime directory-add-modal-date-field"
                         *ngIf="dailyReportsService.selectedItemData.formFields.endDate.editMode">
                        <mat-form-field>
                            <input matInput [(ngModel)]="dailyReportsService.selectedItemData.endDate"
                                   [min]="dailyReportsService.selectedItemData.startDate"
                                   (focus)="dateFromPicker.open()" (click)="dateFromPicker.open()"
                                   name="endDate" [matDatepicker]="dateFromPicker" placeholder="Choose a date" required>
                            <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
                            <mat-datepicker #dateFromPicker></mat-datepicker>
                        </mat-form-field>
                        <div class="input-group bootstrap-timepicker timepicker" (click)="openTimepicker('#timepicker')">
                            <input id="timepicker" class="form-control input-small" name="endTime"
                                   [ngModel]="getTime(dailyReportsService.selectedItemData.endDate)" required>
                            <span class="input-group-addon"><i class="glyphicon glyphicon-time"></i></span>
                        </div>
                    </div>
                    <div class="dv-value-edit m-t-xs pull-right"
                         style="padding: 0 15px;"
                         *ngIf="dailyReportsService.selectedItemData.formFields.endDate.editMode">
                        <button type="button"
                                style="border-left: 1px solid #dedfe0;"
                                (click)="applyChanges(dailyReportsService.selectedItemData, form, {endDate: form.value.endDate}, 'endDate')">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button"
                                (click)="setEditModeFor(dailyReportsService.selectedItemData, 'endDate', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <div class="row m-b-xs"
                     (dblclick)="setEditModeFor(dailyReportsService.selectedItemData, 'relieved', true)">
                    <div class="dv-label col-md-3">
                        <label>Relieved</label>
                    </div>
                    <div class="dv-value col-md-9" *ngIf="!dailyReportsService.selectedItemData.formFields.relieved.editMode">
                        <span>{{dailyReportsService.selectedItemData.relieved || '-'}}</span>
                        <i *ngIf="dailyReportsService.selectedItemData.status === 'draft' && dailyReportsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(dailyReportsService.selectedItemData, 'relieved', true)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    </div>
                    <div class="dv-value-edit col-md-9" *ngIf="dailyReportsService.selectedItemData.formFields.relieved.editMode">
                        <input class="form-control" name="relieved" [ngModel]="dailyReportsService.selectedItemData.relieved" required
                               maxlength="255" (keyup.enter)="applyChanges(dailyReportsService.selectedItemData, form, 'relieved')">
                        <button type="button" (click)="applyChanges(dailyReportsService.selectedItemData, form, {relieved: form.value.relieved})">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="setEditModeFor(dailyReportsService.selectedItemData, 'relieved', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <div class="row m-b-xs"
                     (dblclick)="setEditModeFor(dailyReportsService.selectedItemData, 'relievedBy', true)">
                    <div class="dv-label col-md-3">
                        <label>Relieved By</label>
                    </div>
                    <div class="dv-value col-md-9" *ngIf="!dailyReportsService.selectedItemData.formFields.relievedBy.editMode">
                        <span>{{dailyReportsService.selectedItemData.relievedBy || '-'}}</span>
                        <i *ngIf="dailyReportsService.selectedItemData.status === 'draft' && dailyReportsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                           (click)="setEditModeFor(dailyReportsService.selectedItemData, 'relievedBy', true)"
                           data-toggle="tooltip" data-placement="top" title="Edit"></i>
                    </div>
                    <div class="dv-value-edit col-md-9" *ngIf="dailyReportsService.selectedItemData.formFields.relievedBy.editMode">
                        <input class="form-control" name="relievedBy" [ngModel]="dailyReportsService.selectedItemData.relievedBy" required
                               maxlength="255" (keyup.enter)="applyChanges(dailyReportsService.selectedItemData, form, 'relievedBy')">
                        <button type="button" (click)="applyChanges(dailyReportsService.selectedItemData, form, {relievedBy: form.value.relievedBy})">
                            <i class="fa fa-check"></i>
                        </button>
                        <button type="button" (click)="setEditModeFor(dailyReportsService.selectedItemData, 'relievedBy', false)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>

                <div class="row m-b-xs">
                    <div class="dv-label col-md-3">
                        <label>Report By</label>
                    </div>
                    <div class="dv-value col-md-9">
                        {{dailyReportsService.selectedItemData.reportedBy || '-'}}
                    </div>
                </div>

                <hr class="m-n">

                <!-- ___ Date To ___ -->
                <div class="row m-b-md m-t-md" *ngIf="dailyReportsService.selectedItemData.isCanEdit">
                    <div class="col-md-3">
                        <label>Date To</label>
                    </div>
                    <div class="dv-value-edit col-md-9 inlineDateAndTime directory-add-modal-date-field">
                        <mat-form-field>
                            <input matInput [(ngModel)]="newEntryDate" name="date"
                                   (focus)="picker.open(); isClickedByDataTo = true" (click)="picker.open(); isClickedByDataTo = true"
                                   [matDatepicker]="picker" placeholder="Choose a date" required>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <div class="input-group bootstrap-timepicker timepicker" (click)="openTimepicker('#timepicker2'); isClickedByDataTo = true">
                            <input id="timepicker2"
                                   class="form-control input-small"
                                   name="time"
                                   style="height: 26px;"
                                   [ngModel]="newEntryTime" required>
                            <span class="input-group-addon"><i class="glyphicon glyphicon-time"></i></span>
                        </div>
                    </div>
                </div>

                <textarea class="form-control m-b-md"
                          name="details"
                          [(ngModel)]="details"
                          *ngIf="dailyReportsService.selectedItemData.isCanEdit"
                          placeholder="Add entry"
                          [title]="dailyReportsService.selectedItemData.status != 'closed' ? '' : 'Entries cannot be added to Closed reports'"
                          [disabled]="dailyReportsService.selectedItemData.status == 'closed'"
                          (change)="entryTyped($event.target.value || !noEntriesEdited())"></textarea>

                <button class="btn btn-default btn-sm font-light"
                        (click)="addEntry()"
                        *ngIf="dailyReportsService.selectedItemData.isCanEdit"
                        [title]="dailyReportsService.selectedItemData.status != 'closed' ? '' : 'Entries cannot be added to Closed reports'"
                        [disabled]="!details || disabledEntrySubmit || dailyReportsService.selectedItemData.status == 'closed'">
                    Add entry
                </button>

                <div class="entries-sorting-container m-t-sm">
                    <span class="bold">Entries</span>
                    <div class="pull-right">
                        <span data-toggle="dropdown">
                            <span class="bold">Sort By</span>: {{order == 'asc' ? 'Ascending' : 'Descending'}}
                            <span class="caret"></span>
                        </span>
                        <ul class="dropdown-menu">
                            <li (click)="sortEntries('asc');">
                                <a>Sort Ascending</a>
                            </li>
                            <li (click)="sortEntries('desc');">
                                <a>Sort Descending</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="timeline" *ngIf="dailyReportsService.selectedItemData.entries.length > 0">
                    <div>
                        <ul class="timeline__list">
                            <li *ngFor="let e of dailyReportsService.selectedItemData.entries; trackBy: trackByFn; let index = index;">
                                <section>
                                    <header class="timeline__header">
                                        <span>
                                            <time>{{ e.createdAt | mccDate : true : true }}</time> - {{ e.createdBy ? e.createdBy.fullName : '-' }}
                                        </span>
                                    </header>

                                    <main class="timeline__content">
                                        <div>
                                            {{ e.dateTo | date:'yyyy-MM-dd hh:mma'}}
                                        </div>
                                        <div>
                                            <div class="dv-value" *ngIf="!e.editMode">
                                                <pre>{{e.details}}</pre>
                                                <i *ngIf="dailyReportsService.selectedItemData.status === 'draft' && dailyReportsService.selectedItemData.isCanEdit"
                                                   class="fa fa-pencil pull-right"
                                                   (click)="e.editMode = true;"
                                                   data-toggle="tooltip" data-placement="top" title="Edit"></i>
                                                <i *ngIf="dailyReportsService.selectedItemData.status === 'draft' && dailyReportsService.selectedItemData.isCanEdit"
                                                   (click)="removeEntry(index)"
                                                   class="fa fa-trash pull-right"
                                                   title="Delete"></i>
                                            </div>
                                            <div class="dv-value-edit m-t-sm" *ngIf="e.editMode">
                                                <textarea class="form-control"
                                                          name="entry{{index}}"
                                                          id="entry{{index}}"
                                                          [ngModel]="e.details"
                                                          required
                                                          (change)="entryTyped($event.target.value != e.details || details)"
                                                          maxlength="255"
                                                          (keyup.enter)="editEntry(index, form)"></textarea>
                                                <button type="button" (click)="editEntry(index, form)" [disabled]="disabledEntrySubmit">
                                                    <i class="fa fa-check"></i>
                                                </button>
                                                <button type="button"
                                                        (click)="closeEntryEditing(e, index)"
                                                        [disabled]="disabledEntrySubmit">
                                                    <i class="fa fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </main>
                                </section>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>

            <hr>

            <div class="btn-group dropup">
                <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                    Actions <span class="caret"></span>
                </a>
                <ul class="dropdown-menu">
                    <li (click)="dailyReportsService.viewReport(dailyReportsService.selectedItemData)">
                        <a>View Report</a>
                    </li>
                    <li (click)="dailyReportsService.getPDF(dailyReportsService.selectedItemData)"><a>Print</a></li>
                    <li (click)="dailyReportsService.close(dailyReportsService.selectedItemData)"
                        *ngIf="dailyReportsService.selectedItemData.status != 'closed' && dailyReportsService.selectedItemData.isCanEdit">
                        <a>Close</a>
                    </li>
                    <li (click)="dailyReportsService.deleteEntry(dailyReportsService.selectedItemData)"
                        *ngIf="dailyReportsService.selectedItemData.status != 'closed' && dailyReportsService.selectedItemData.isCanDelete">
                        <a>Delete Report</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports-detailed-view/daily-reports-detailed-view.component.html